<div class="ha-primary-care-section section-wrapper">
	<div class="heading">
		<span [translate]="'wellness.health-assessment-new.general-information.primary-care.heading'">
			Primary Care Physician
		</span>
	</div>
	<div class="form-group" [formGroup]="primaryCareForm" id="general-primarycare">
		<div>
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.general-information.primary-care.form-fields.have-physician'">
				Do you have a primary care physician?
			</div>
			<fieldset>
				<mat-radio-group formControlName="havePrimaryCarePhysician">
					<mat-radio-button appAutofocus [value]="true">
						<span
							[translate]="'wellness.health-assessment-new.general-information.primary-care.form-fields.option-yes'">
							Yes
						</span>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.general-information.primary-care.form-fields.option-no'">
							No
						</span>
					</mat-radio-button>
				</mat-radio-group>
			</fieldset>
		</div>
		<ng-container *ngIf="primaryCareForm.get('havePrimaryCarePhysician').value">
			<div class="form-field input-fields inline-input-field w-60">
				<mat-form-field appearance="fill">
					<mat-label>
						<span [translate]="'wellness.health-assessment-new.general-information.primary-care.form-fields.full-name'">
							Full Name
						</span>
					</mat-label>
					<input matInput formControlName="fullName" [readOnly]="readOnly" />
				</mat-form-field>
			</div>
			<div class="form-field inline-input-field w-40">
				<mat-form-field appearance="fill">
					<mat-label>
						<span [translate]="'wellness.health-assessment-new.general-information.primary-care.form-fields.phone'">
							Phone
						</span>
					</mat-label>
					<input matInput formControlName="phone" [imask]="phoneMask.iMaskArgs" [readOnly]="readOnly" />
					<mat-error>
						<app-error-message [control]="'phone'"></app-error-message>
					</mat-error>
				</mat-form-field>
			</div>
		</ng-container>
	</div>
	<div class="heading">
		<span [translate]="'wellness.health-assessment-new.general-information.specialists.heading'">Specialists</span>
	</div>
	<div [formGroup]="specialistsForm" id="general-specialists">
		<div
			class="radio-btn-label"
			[translate]="'wellness.health-assessment-new.general-information.specialists.form-fields.seen-specialists'">
			Do you see any medical specialists or other health professionals?
		</div>
		<fieldset>
			<mat-radio-group formControlName="seeMedicalSpecialist">
				<mat-radio-button [value]="true">
					<span [translate]="'wellness.health-assessment-new.general-information.specialists.form-fields.option-yes'">
						Yes
					</span>
				</mat-radio-button>
				<mat-radio-button [value]="false">
					<span [translate]="'wellness.health-assessment-new.general-information.specialists.form-fields.option-no'">
						No
					</span>
				</mat-radio-button>
			</mat-radio-group>
		</fieldset>
		<ng-container *ngIf="specialistsForm.get('seeMedicalSpecialist').value">
			<div formArrayName="specialists">
				<div *ngFor="let specialist of specialistsForm.controls.specialists.controls; let i = index; let isLast = last">
					<div [formGroupName]="i">
						<div class="form-field input-fields">
							<mat-form-field appearance="fill">
								<mat-label>
									<span
										[translate]="
											'wellness.health-assessment-new.general-information.specialists.form-fields.speciality'
										">
										Specialty
									</span>
								</mat-label>
								<input matInput formControlName="specialty" [readOnly]="readOnly" />
							</mat-form-field>
						</div>
						<div class="form-field inline-input-field w-60">
							<mat-form-field appearance="fill">
								<mat-label>
									<span
										[translate]="
											'wellness.health-assessment-new.general-information.specialists.form-fields.full-name'
										">
										Full Name
									</span>
								</mat-label>
								<input matInput formControlName="fullName" [readOnly]="readOnly" />
							</mat-form-field>
						</div>
						<div class="form-field inline-input-field w-40">
							<mat-form-field appearance="fill">
								<mat-label>
									<span
										[translate]="'wellness.health-assessment-new.general-information.specialists.form-fields.phone'">
										Phone
									</span>
								</mat-label>
								<input matInput formControlName="phone" [imask]="phoneMask.iMaskArgs" [readOnly]="readOnly" />
								<mat-error>
									<app-error-message
										[control]="'phone'"
										[isFormArray]="true"
										[formGroup]="specialistsForm.controls.specialists.controls[i]"></app-error-message>
								</mat-error>
							</mat-form-field>
						</div>
					</div>
				</div>
				<div class="add-specialist-label">
					<span
						(click)="addSpecialist()"
						[translate]="
							'wellness.health-assessment-new.general-information.specialists.form-fields.add-new-specialist'
						">
						+ Add another specialist
					</span>
				</div>
			</div>
		</ng-container>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button
		class="button button-medium"
		mat-button
		appEheAnalytics
		matStepperNext
		[data]="{
			pageUrl: '/ha/new/(general:primary-care)',
			redirectedTo: '/ha/new/(medical:medical-condition)',
			componentName: 'PrimaryCare',
			id: 'HA General Info - Primary Care',
			placement: 'ha primary care screen'
		}">
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
